import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, Signal, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RecommendJobService } from '../../recommend-job/services/recommend-job.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { finalize, first } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface RecruiterQualifiedRecommendJobDialogData {
    userIds: Signal<number[]>;
    jobId: Signal<number>;
    candidateNames: Signal<string[]>;
}

@Component({
    selector: 'nova-recruiter-qualified-recommend-job',
    standalone: true,
    templateUrl: './recruiter-qualified-recommend-job.component.html',
    styleUrls: ['./recruiter-qualified-recommend-job.component.scss'],
    imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterQualifiedRecommendJobComponent {
    readonly data = inject(MAT_DIALOG_DATA) as RecruiterQualifiedRecommendJobDialogData;
    isRecommending = signal(false);
    spinnerSize = signal(24);

    private readonly dialogRef = inject(MatDialogRef<RecruiterQualifiedRecommendJobComponent>);
    private readonly recommendJobService = inject(RecommendJobService);
    private readonly toasterService = inject(ToasterService);

    close(recommendJobsSuccess = false, hadError = false): void {
        this.dialogRef.close({ success: recommendJobsSuccess, error: hadError });
    }

    sendRecommendations(): void {
        this.isRecommending.set(true);
        this.recommendJobService
            .recommendJobsToMultipleCandidates(this.data.userIds(), [this.data.jobId()])
            .pipe(
                first(),
                finalize(() => this.isRecommending.set(false))
            )
            .subscribe({
                next: (result: boolean) => {
                    if (result) {
                        this.close(true);
                    }
                },
                error: () => {
                    this.toasterService.toast('Failed to send. Please try again');
                }
            });
    }
}
